import { motion } from "framer-motion";
import CardHeading from "@fuse/core/CardHeading/CardHeading";
import { IconButton } from "@mui/material";

function ConnectWithUs() {
	return (
		<div className="flex flex-col sm:flex-row flex-wrap gap-[20px] mt-10">
			<div className="flex w-full flex-col">
				<motion.div
					initial={{ x: 20, opacity: 0 }}
					animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}
				>
					<CardHeading
						heading="Connect with us!"
						customClassHeading="font-quicksand font-700 text-18px sm:text-22px leading-22px sm:leading-26px text-peeva-black"
						subHeading="Follow Peeva on social media for pet safety tips, lost-and-found success stories, and exclusive offers - plus a daily dose of furry faces who made it home."
						customClassSubHeading="text-16px font-400 tracking-tight leading-22px"
					/>
				</motion.div>

				<div className="flex justify-center sm:justify-start mt-4 space-x-6">
					<IconButton
						aria-label="Facebook"
						onClick={() => window.open("https://www.facebook.com/profile.php?id=100084782302799", "_blank")}
					>
						<img
							src="/assets/icons/facebook.png"
							alt="Facebook"
							style={{ width: 48, height: 48, objectFit: 'contain' }}
						/>
					</IconButton>

					<IconButton
						aria-label="Instagram"
						onClick={() => window.open("https://www.instagram.com/peevapets/", "_blank")}
					>
							<img
								src="/assets/icons/instagram.png"
								alt="Instagram"
								style={{ width: 48, height: 48, objectFit: 'contain' }}
							/>
					</IconButton>

					<IconButton
						aria-label="TikTok"
						onClick={() => window.open("https://www.tiktok.com/@peevapets?", "_blank")}
					>
						<img
							src="/assets/icons/tiktok.png"
							alt="TikTok"
							style={{ width: 48, height: 48, objectFit: 'contain' }}
						/>
					</IconButton>

					<IconButton
						aria-label="Linkedin"
						onClick={() => window.open("https://www.linkedin.com/company/peeva/", "_blank")}
					>
						<img
							src="/assets/icons/linkedin.png"
							alt="LinkedIn"
							style={{ width: 48, height: 48, objectFit: 'contain' }}
						/>
					</IconButton>

				</div>
			</div>
		</div>
	);
}

export default ConnectWithUs;
